export const en = {
    "k_5f280f85": "You are imitating user {arg_0}, and relevant operations will be recorded. Please standardize the operations."
};
